import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

// styles
import style from '../../Styles/Containers/Modal_Alert.module.css'

// component
import Header from '../Header/header'

class ModalAlertComponent extends Component {
    constructor() {
        super();
    }
    render() {
        return (
            this.props.visible ? <div className={style.mask}>
                <div className={style.modal}>
                    <div className={style.top_content}>{this.props.topContent}</div>
                    <div className={style.middle_content}>{this.props.middleContent}</div>
                    <div className={style.bottom_content}>{this.props.bottomContent}</div>


                    <div className={style.confirm}>
                        <span 
                            className={style.confirm_font} 
                            onClick={this.props.onConfirm && this.props.onConfirm.bind(this)}>
                                {this.props.confirmFont || "확인"}
                        </span>
                    </div>
                </div>
            </div>
            :
            null
        )
    }
}

export default connect()(withRouter(ModalAlertComponent))